/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExternalDocumentation } from '../../core/models/common/ExternalDocumentation';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExternalDocumentation
 */
export abstract class OasExternalDocumentation extends ExternalDocumentation {
    constructor() {
        super();
    }
}
OasExternalDocumentation["__class"] = "io.apicurio.datamodels.openapi.models.OasExternalDocumentation";
OasExternalDocumentation["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




